import { z } from "zod";

export const PaginatedSearchSchema = z.object({
  page: z.number().optional().default(1),
  perPage: z.number().optional().default(10),
  sort: z.string().optional(),
  filters: z
    .array(
      z.object({
        id: z.string(),
        value: z.union([z.string(), z.array(z.string())]),
        variant: z.string(),
        operator: z.string(),
        filterId: z.string(),
      }),
    )
    .optional()
    .default([]),
  joinOperator: z.enum(["and", "or"]).optional().default("and"),
});
